import { memo, useEffect } from 'react'
import { useMap } from '@vis.gl/react-google-maps'
import { COLORS } from '@/styles'
import { RouteLineProps } from './RouteLine.types'

// Dash segment repeated along the line to render a dotted route.
const DASH_SYMBOL = {
  path: 'M 0,-1 0,1',
  strokeOpacity: 1,
  scale: 3,
  strokeColor: COLORS.AZURE_SKY,
}

function RouteLine({ path }: RouteLineProps) {
  const map = useMap()

  useEffect(() => {
    if (!map || path.length < 2) return

    const line = new google.maps.Polyline({
      map,
      path,
      geodesic: true,
      clickable: false,
      strokeOpacity: 0,
      icons: [{ icon: DASH_SYMBOL, offset: '0', repeat: '16px' }],
    })

    return () => line.setMap(null)
  }, [map, path])

  return null
}

export default memo(RouteLine)
